import { render, staticRenderFns } from "./TrendingSpotlightModuleCard.vue?vue&type=template&id=5c5e5433&scoped=true"
import script from "./TrendingSpotlightModuleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrendingSpotlightModuleCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TrendingSpotlightModuleCard.vue?vue&type=style&index=0&id=5c5e5433&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5e5433",
  null
  
)

export default component.exports